/* global ShoppingBasketStore */

import $ from 'jquery';
import {render} from 'react-dom';

import 'topmeteo/utils/legacy/DatePicker';

import formatCurrency from '../utils/formatCurrency';

import Portal from '../general/components/Portal';

import CurrencySwitch from './components/CurrencySwitch';
import ShoppingBasket from './components/ShoppingBasket';
import ForecastRegions from './components/ForecastRegions';

import initTabs from './tabs';

let initialised = false;

const expose = [
    'setRegion',
    'setDiscount',
    'setDuration',
    'setStartDate',
    'toggleOption',
];

window.ShoppingBasket = ({step, currency, ...initialData}) => {
    if (initialised) throw new Error('ShoppingBasket could only be initialised once.');

    const ShoppingBasketNode = document.getElementById('shopping-basket');
    const fmtCurrency = value => formatCurrency(currency, value);

    const basket = render(
        <ShoppingBasket
            {...initialData}
            formatCurrency={fmtCurrency}
        />,
        ShoppingBasketNode,
    );

    const store = {};

    expose.forEach(name => {
        store[name] = basket[name].bind(basket);
    });

    initialised = true;

    return store;
};

window.CurrencySwitch = (name, currencies, defaultCurrency) => render(
    <CurrencySwitch name={name} currencies={currencies} defaultCurrency={defaultCurrency} />,
    document.getElementById('currency-switch'),
);

window.ForecastRegions = props => {
    const ForecastRegionsNode = document.getElementById('forecast-regions');
    const ShopContentNode = document.getElementsByClassName('shop-content')[0];

    return render(
        <Portal container={ShopContentNode}>
            <ForecastRegions {...props} />
        </Portal>,
        ForecastRegionsNode,
    );
};

window.OptionsStep = (id, options) => {
    $(() => {
        const jqOptions = $(`#${id}`);

        jqOptions.on('change', 'input', function handleChange() {
            ShoppingBasketStore.toggleOption(options[this.value], this.checked);
        });

        jqOptions.on('click', '.details-link', function handleClick(event) {
            $(this).siblings('.details').toggleClass('hidden');

            /* avoid checking the checkbox when toggling the details */
            event.preventDefault(); event.stopPropagation();
        });

        initTabs('.tabs', 'active');
    });
};

window.ToS = () => {
    $(() => {
        const jqTermsOfServiceCheckbox = $('#terms-of-service-checkbox');
        const jqSubmitButton = $('#submit-button');

        jqTermsOfServiceCheckbox.on('change', function handleChange() {
            jqSubmitButton.prop('disabled', this.checked === false);
        });
    });
};

window.PSP = URLs => {
    const jqForm = $('#shop-selection');
    const jqPaymentMethod = $('#payment-method');
    const jqTeleCashMessage = $('#telecash-message');
    const jqXolvisMessage = $('#xolvis-message');
    const inputSelector = 'input[type=radio]';

    jqPaymentMethod.on('change', inputSelector, function handleChange() {
        const psp = $(this).data('psp');

        jqForm.prop('action', URLs[psp] || '.');
        jqTeleCashMessage.css('display', psp === 'telecash' ? 'block' : 'none');
        jqXolvisMessage.css('display', psp === 'xolvis' ? 'block' : 'none');
    });

    jqPaymentMethod.find(`${inputSelector}:checked`).trigger('change');
};

const PayPalSDKBaseURL = 'https://www.paypal.com/sdk/js';

window.PayPalPlus = (clientID, orderID, containerID, inputID, currency, locale, fundingSource, debug) => {
    /* global paypal */

    const params = new URLSearchParams({
        'client-id': clientID,
        'integration-date': '2023-11-30',
        commit: false,
        currency,
        locale,
        debug,
    });

    const scriptNode = document.createElement('script');

    scriptNode.async = true;
    scriptNode.src = `${PayPalSDKBaseURL}?${params.toString()}`;
    scriptNode.onload = () => {
        const buttons = paypal.Buttons({
            fundingSource,
            createOrder: () => Promise.resolve(orderID),
            onApprove({orderID}) {
                const inputNode = document.getElementById(inputID);

                inputNode.value = orderID;

                inputNode.form.submit();
            },
            onCancel({orderID}) {
                window.location.href = `cancel/${orderID}/`;
            },
        });

        buttons.render(containerID);
    };

    document.body.append(scriptNode);
};
